import { gql } from '@apollo/client'

export const UPDATE_PATIENTS_WITH_PREVIOUS_MEDICAL_RECORD = (
  isOmnichannel: boolean,
) => gql`
  mutation UpdatePatientsWithPreviousMedicalRecord(
    $businessId: ID
    $clientId: ID!
    $input: [UpdatePatientInput!]!
  ) {
    updatePatientsBatch(
      businessId: $businessId
      clientId: $clientId
      input: $input
    ) {
      id
      name
      sendReminders
      previousMedicalRecord {
        id
        priorVetCareStatus {
          id
          name
        }
        consentStatus {
          id
          name
        }
        internalNotes
        contacts {
          id
          name
          email
          phone
          city
          state
          zip
          ${isOmnichannel ? 'kyriosId' : ''}
        }
        createdAt
        updatedAt
      }
    }
  }
`
